import {ExperimentNames, isDonationTicketDefinition} from '@wix/wix-events-commons-statics'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {CloseSmall, DeleteSmall, SelectFill} from '@wix/wix-ui-icons-common/on-stage'
import {useEnvironment, useExperiments, useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {Divider, IconButton} from 'wix-ui-tpa/cssVars'
import {useColors} from '../../../../../hooks/colors'
import {usePageActions, usePageStateSelector} from '../../../../../hooks/state'
import {isInMobileBasket} from '../../../../../selectors/seating/mode'
import {getPlaceInfoText, isPlaceInBasket, shouldShowSeatInfo} from '../../../../../selectors/seating/place'
import {WholeElementReservation} from '../whole-element-reservation'
import {CustomDatesLabel} from './custom-dates-label'
import {TicketInfoProps} from './interfaces'
import {SeatInfo} from './seat-info'
import {TicketInfoTexts} from './ticket-info-texts'
import {classes} from './ticket-info.st.css'

export const TicketInfo = ({
  place,
  showAccessibilityMode,
  inDrawer,
  onCloseClick,
  onRemoveClick,
  inPopover,
  basketView,
  inDescription,
  selected,
}: TicketInfoProps) => {
  const {t} = useTranslation()
  const {isMobile} = useEnvironment()

  const {resetAreaCounterValue} = usePageActions()
  const mobileBasketView = usePageStateSelector(isInMobileBasket)

  const {experiments} = useExperiments()
  const planTicketsDesignEnabled = experiments.enabled(ExperimentNames.PlanTicketsDesign)

  const {darkColor} = useColors()
  const showCustomDatesLabel = inDrawer || showAccessibilityMode || inPopover
  const inBasket = isPlaceInBasket(place)
  const isDonation = place.ticket ? isDonationTicketDefinition(place.ticket) : false
  const showCheckbox = inBasket && !selected && !basketView && !inPopover && !inDescription
  const showSeatInfo = shouldShowSeatInfo(place)

  const handleTicketInfoClose = () => {
    onCloseClick()
    resetAreaCounterValue({place, keepQuantityIfNeeded: true})
  }

  return (
    <div className={classes.container}>
      {onCloseClick ? (
        <IconButton
          data-hook={DH.CLOSE_DRAWER}
          className={classes.headerButton}
          icon={<CloseSmall />}
          onClick={handleTicketInfoClose}
        />
      ) : null}
      {showCheckbox ? (
        <SelectFill
          className={classNames(classes.checkbox, {
            [classes.checkboxFillWired]: darkColor,
            [classes.checkboxFillNotWired]: !darkColor,
          })}
        />
      ) : null}
      {!planTicketsDesignEnabled && onRemoveClick ? (
        <IconButton
          data-hook={DH.REMOVE_TICKET}
          className={classes.headerButton}
          icon={<DeleteSmall />}
          onClick={onRemoveClick}
          aria-label={`${t('seatings_removeFromBasket')} ${getPlaceInfoText(place, t)}`}
        />
      ) : null}
      {showCustomDatesLabel && <CustomDatesLabel place={place} />}
      <TicketInfoTexts
        forcePricingOptionRangeLabel={
          planTicketsDesignEnabled && isMobile && !mobileBasketView && !showAccessibilityMode
        }
        place={place}
        inPopover={inPopover}
        inDrawer={inDrawer}
      />
      {(inPopover || inDrawer) && !isDonation ? (
        <WholeElementReservation place={place} basketView={false} inDescription={false} showAccessibilityMode={false} />
      ) : null}
      {planTicketsDesignEnabled && showSeatInfo && inPopover ? (
        <>
          <Divider className={classes.divider} />
          <SeatInfo place={place} />
        </>
      ) : null}
    </div>
  )
}
